require('element-matches-polyfill');

document.addEventListener("DOMContentLoaded", function () {

    const focusTrap = require('focus-trap');
	let trap = false;

	let nav = document.getElementById('nav');
    let mobile_nav = document.getElementById('mobile-nav');

    nav.addEventListener('click', toggle_child_menu, false);
    nav.addEventListener('click', toggle_mobile_menu, false);
    document.addEventListener('click', toggle_mobile_sub_menu, false);

	document.addEventListener('mouseover', watch_for_close, false);
	window.addEventListener('resize', close_nav_on_resize);

    document.addEventListener('click', toggle_footer_menu, false);

    function debounce(func, wait = 100) {
		let timeout;

		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				func.apply(this, args);
			}, wait);
		};
	}

	function toggle_child_menu(event) {

		if (event.target.classList.contains('parent-link-toggle')) {

            //prevent the default action
            event.preventDefault();

            //start our count at 0
            let liCount = 0;

            //define our current element
            let currentElement = event.target;

            //move up the DOM until we find the container div
            while (currentElement && currentElement.tagName !== 'div') {

                //if this is a list item
                if (currentElement.tagName === 'LI') {

                    //increment our count
                    liCount++;
                }

                //update our current element
                currentElement = currentElement.parentElement;
            }

            //if this is the highest level menu item
            if(liCount === 1) {

                //close all other items first (if any are open)
                close_child_menu();
            }

            //find our a tag
            let a_tag = event.target.previousElementSibling;

            //if the clicked element is a mobile menu item
            if(a_tag.classList.contains('mobile-menu-item')) {

                //set the focus trap to be our sub menu
                set_nav_focus_trap(a_tag.parentElement);
            }

            //toggle the active status...
            a_tag.classList.toggle('active');

            //if this is a mobile parent item, we need to make some changes for grandchildren links
            if(a_tag.classList.contains('mobile-menu-item') && a_tag.parentElement.classList.contains('menu-item-has-children')) {

                //remove existing temp styles
                remove_temp_styles(a_tag);

                //calculate the height of the sub menus
                let sub_menu_height = (a_tag).nextElementSibling.nextElementSibling.clientHeight;

                //get the parent li and grandparent list
                let parent_li = (a_tag).parentElement;
                let grandparent_list = parent_li.parentElement;

                //defines our default placement
                let placement = 0;

                //find the placement of the parent li in the grandparent list
                for(placement = 0; placement < grandparent_list.children.length; placement++) {

                    //if we've found the parent li
                    if(grandparent_list.children[placement] == parent_li) {

                        //stop the loop
                        break;
                    }
                }

                //if we have an ID
                if(a_tag.parentElement.id) {

                    //create a new style element
                    let styles = document.createElement('style');
                    styles.id = 'temp-sub-menu-styles';
                    styles.dataset.target = a_tag.parentElement.id;

                    //creates our base selector
                    let selector = '#' + (a_tag.parentElement.id) + ' + li';

                    //adds the styles for the sub menu (we support up to 10 sub menus deep)
                    for(let i = 0; i < 10; i++) {

                        //if this is not the first item or it's first and an even numbered item
                        if(i != 0 || i === 0 && placement % 2 == 0) {

                            //add the offset
                            selector = selector + '+ li + li';
                        }

                        //add the styles
                        styles.innerHTML = styles.innerHTML + selector + ` { margin-top: -${sub_menu_height}px !important; }`;
                    }

                    //append the styles to the head
                    document.head.appendChild(styles);
                }
            }

            //if we have at least one active item...
            if(document.querySelectorAll('a.active').length >= 1) {

                //show the shade
                document.body.classList.add('nav-shade');
            } else { //otherwise all our nav items must be closed...

                //hide the shade
                document.body.classList.remove('nav-shade');
            }
        }
	}

	function close_child_menu() {

		//fetch open menus
		let open_menus = document.querySelectorAll('a.active');

		//if we have some open menus
		if (open_menus) {

			//loop through then
			for (let i = 0; i < open_menus.length; i++) {

				open_menus[i].classList.remove('active');
			}
		}

        //remove our temp styles (if they exist)
        remove_temp_styles();

        //remove our nav shade
        document.body.classList.remove('nav-shade');
        open_sub_menu = false;

	}

    function remove_temp_styles(preserve_current = false) {
        //check to see if our temp styles exist
        let temp_styles = document.getElementById('temp-sub-menu-styles');

        //if they do...
        if(temp_styles) {

            //if we have a target selector on the styles itself
            if(temp_styles.dataset.target) {

                //find the target
                let target = document.querySelector('#' + temp_styles.dataset.target + ' a');

                //if we have a target
                if(!preserve_current && target || preserve_current && target && target != preserve_current) {

                    //make it inactive
                    target.classList.remove('active');
                }
            }

            //remove the styles
            temp_styles.remove();
        }
    }

    function watch_for_close(event) {

        //if this is mobile, ignore any events
        if (!window.matchMedia("(min-width: 1280px)").matches) {
            return;
        }

        // If we're not hovering over the nav, parent link, sub menu or item
        if (!event.target.matches('#menu-main-nav') &&
            !event.target.matches('.desktop-parent-link-toggle') &&
            !event.target.matches('.parent-link-toggle') &&
            !event.target.matches('.desktop-parent-link') &&
            !event.target.matches('.menu-item-has-children') &&
            !event.target.matches('.sub-menu') &&
            !event.target.matches('.menu-item') &&
            !event.target.matches('.mobile-menu-item')) {

                //close all menus
                close_child_menu();
        }
    }

    function toggle_mobile_menu(event) {

        // If the clicked element isn't the hamburger, return
        if (!event.target.matches('#hamburger')) return;

        //if the nav is not already open open
        if(!document.body.classList.contains('nav-open')) {

            //add the active class
            document.body.classList.add('nav-open');

            //set up our focus trap
            set_nav_focus_trap();
        } else {

            //remove the active class
            document.body.classList.remove('nav-open');

            //clear the focus trap
            clear_nav_focus_trap();
        }

        //add this class to indicate the nav has been opened
        document.body.classList.add('nav-opened');

        //attempt to find any open menu items
        let open_menu_items = document.querySelectorAll('.mobile-menu-item.active, .mobile-submenu-item.active');

        //if we have some open menus
        if(open_menu_items && open_menu_items.length > 0) {

            //loop through them
            for(let i = 0; i < open_menu_items.length; i++) {

                //remove the active class
                open_menu_items[i].classList.remove('active');
            }
        }
    }

    function toggle_footer_menu(event) {

		// If the clicked element isn't the footer menu name, return
		if (!event.target.matches('.footer-menu-name')) return;

		//toggle the open class on the body
		event.target.classList.toggle('open');
    }

    function toggle_mobile_sub_menu(event) {
        // If the clicked element isn't the close mobile sub-menu, return
        if (!event.target.matches('.sub-menu-close')) return;

        //toggle the open class on the body
        event.target.parentElement.parentElement.previousElementSibling.previousElementSibling.classList.toggle('active');

        //attempt to find any open child menus
        let child_menus = (event.target.parentElement.parentElement).querySelectorAll('.mobile-submenu-item.active');

        //if we have some child menus
        if(child_menus && child_menus.length > 0) {

            //loop through them
            for(let i = 0; i < child_menus.length; i++) {

                //remove the active class
                child_menus[i].classList.remove('active');
            }
        }

        //clear the focus trap
        clear_nav_focus_trap();

        //re-initialize the focus trap (using the top level nav)
        set_nav_focus_trap();
    }

	function set_nav_focus_trap(target = false) {

        //if this is mobile
        if(window.matchMedia("(max-width: 1280px)").matches) {

            //if we've not been provided with a target
            if(target === false) {

                //default to the mobile nav
                target = mobile_nav;
            }
        } else { //otherwise, it's desktop

            //blank the target
            target = false;
        }

        //if we have a trap already
		if (trap) {

			//deactivate the current trap
			trap.deactivate();
		}

        //if we have a target
        if(target) {

            //re-intiialize the trap with the new target
            trap = focusTrap.createFocusTrap(
                [
                    document.getElementsByTagName('header')[0],
                    target
                ]
            );

            //wait 100s for initialization
            setTimeout(function () {

                //activate it
                trap.activate();
            }, 100);
        }
	}

    function clear_nav_focus_trap() {

        //if we have a trap
        if(trap) {

            //deactivate it
            trap.deactivate();
        }

        //reset the trap
        trap = false;
    }

	function close_nav_on_resize(event) {

        //close mobile nav
        document.body.classList.remove('nav-open');

        //close any child menus
        close_child_menu();

        //if the trap currently exists
        if(trap) {
            //deactivate focus trap
            trap.deactivate();
        }
	}

    document.addEventListener('keydown', function(event) {
        // Check if the pressed key is 'Esc'
        if (event.key === "Escape" && document.body.classList.contains('nav-shade') || event.keyCode === 27 && document.body.classList.contains('nav-shade')) {
            // alert('Escape key pressed');
            close_child_menu();
            // Find the active sub-menu
            let activeSubMenu = document.querySelector('.sub-menu.active, .mobile-submenu-item.active');
            if (activeSubMenu) {
                // Close the sub-menu
                activeSubMenu.classList.remove('active');
                // Find the parent menu item and set focus to it
                let parentMenuItem = activeSubMenu.closest('.menu-item-has-children').querySelector('a');
                if (parentMenuItem) {
                    parentMenuItem.focus();
                }
                clear_nav_focus_trap();

                if(window.matchMedia("(max-width: 1280px)").matches) {
                    set_nav_focus_trap(mobile_nav);
                }
            }
        }
    });
});